import { keepValueUnchanged } from '../../field-viewer/shared-normalizers';
export const fileUploadViewer = {
    normalizeLoadedValue: keepValueUnchanged
};

//# sourceMappingURL=definition-viewer.js.map